const AnalyserModalPopupListeners = (function () {
    /**
     * showModal : changing html element display in block
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param modal string
     */
    const showModal = (modal) => {
        modal.css('display', 'block');
    };
    /**
     * showModal : changing html element display in block
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param modal string
     */
    const hideModal = (modal) => {
        modal.css('display', 'none');
    };
    return {
        showModal,
        hideModal
    };
})();
